import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import LandingPage from "../../pages/public/LandingPage";

const LandingPageWrapper: React.FC = () => {
  const { user, hydrationPending } = useAuthStore();

  // 스토어 상태가 로딩 중인 경우 아무것도 렌더링하지 않음
  if (hydrationPending) {
    return null;
  }

  // 로그인된 사용자라면 /workspace로 자동 리다이렉트
  if (user) {
    return <Navigate to="/workspace" replace />;
  }

  // 비로그인 사용자라면 랜딩페이지 표시
  return <LandingPage />;
};

export default LandingPageWrapper;
